import React, { useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { CreateAlvnce, GetAlv } from "../../../features/Emp/EmpSlice";
import "./CreateAllowances.css";
import { toast } from "react-toastify";
import axios from "axios";
import dayjs from "dayjs";
import { Snackbar, Alert } from "@mui/material";
import { Tooltip } from "@mui/material";
import { base_url } from "../../../utils/AxiosConfig";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import EditIcon from "@mui/icons-material/Edit";
import { Plus } from "lucide-react";
import CloseIcon from "@mui/icons-material/Close";
import BusinessIcon from "@mui/icons-material/Business";

let alvnceschema = Yup.object().shape({
  CmpCode: Yup.string(),
  EmpId: Yup.string(),
  AllowanceType: Yup.string(),
  Amount: Yup.string(),
  ADate: Yup.string(),
  AffectOTCalc: Yup.string(),
});
const CreateAllowance = ({ calculationAlv, EmpIdTop, getAllowanceList }) => {
  const ref = useRef();
  const empStateAlv = useSelector((state) => state?.emp.GetAlv);
  const [emp, setEmp] = useState(null);
  const [data, setData] = useState(null);
  const dispatch = useDispatch();

  const creationOfAllowance = useSelector((state) => state?.emp.CreateAlvnce);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    console.log(
      "created allowance successfully creationOfAllowance",
      creationOfAllowance,
    );
    if (!creationOfAllowance) return;
    if (creationOfAllowance) {
      console.log("created allowance successfully");
      setOpenSnackbar(true); // success
    } else {
      setErrorMessage("Failed to create allowance");
      setOpenErrorSnackbar(true); // error
    }
  }, [creationOfAllowance]);

  console.log(
    "emp in create allowance , empStateAlv, creationOfAllowance",
    emp,
    empStateAlv,
    creationOfAllowance,
  );

  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  let companyCode = null;

  if (storedUserDataArray) {
    companyCode = storedUserDataArray[0].cmpcode;
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      CmpCode: companyCode,
      EmpId: EmpIdTop || "",
      // EmpId: empStateAlv ? empStateAlv[0]?.EmpID : "-",
      AllowanceType: "",
      Amount: 0,
      // ADate: "2024-01-02",
      ADate: new Date().toLocaleDateString("en-CA"),
      AffectOTCalc: "",
    },
    validationSchema: alvnceschema,
    onSubmit: async (values, { resetForm }) => {
      console.log(values);
      setEmp(values.EmpId);
      setData(values);

      // dispatch(CreateAlvnce([values]));
      await createAllowance(values);
      resetForm();
    },
  });

  useEffect(() => {
    if (data) {
      dispatch(CreateAlvnce([data]));
    }
  }, [data]);

  useEffect(() => {
    // let Incsum=IncrementDat?.reduce((a,v) =>  a = a + v.Amount , 0 )
    let AlvSum = empStateAlv?.reduce((a, v) => (a = a + v.Amount), 0);

    calculationAlv(AlvSum);
    // setAlvTotal(AlvSum)
  }, [empStateAlv]);

  const isCreateDisabled =
    !EmpIdTop ||
    !formik.values.AllowanceType ||
    formik.values.Amount === "" ||
    !formik.values.ADate ||
    !formik.values.AffectOTCalc;

  const createAllowance = async (values) => {
    try {
      const response = await axios.post(
        `${base_url}/api/PersonalInfoAllowanceReg`,
        [values],
      );

      if (response.data) {
        // Show success snackbar
        setOpenSnackbar(true);
        if (getAllowanceList) {
          getAllowanceList(EmpIdTop);
        }
        return response.data;
      }
    } catch (error) {
      console.error("Error creating allowance:", error);
      setErrorMessage(
        error.response?.data?.message || "Failed to create allowance",
      );
      setOpenErrorSnackbar(true);
    }
  };
  const [showAllowanceCreationEditPopup, setShowAllowanceCreationEditPopup] =
    useState(false);

  // Allowance
  const initialAllowanceInAction = {
    allowance_name: "",
    transaction_id: "ED54A276-A746-4649-B085-43CBBAEB7371", // dummy transaction id
    mode: "ENTRY",
  };

  // Allowance
  const [allowanceNameInInputBoxNew, setAllowanceNameInInputBoxNew] = useState(
    initialAllowanceInAction,
  );

  // Allowance
  const initialAllowanceInActionEdit = {
    allowance_name: "",
    transaction_id: "",
    mode: "EDIT",
  };

  // Allowance
  const [allowanceNameInInputBoxEdit, setAllowanceNameInInputBoxEdit] =
    useState(initialAllowanceInActionEdit);

  // Allowance
  const [allowanceListFromAPI, setAllowanceListFromAPI] = useState(null);

  // Allowance
  const newAllowanceAPI = () => {
    let apiUrl = `${base_url}/api/MasterReg/ENTRY/${companyCode}/ALLOWANCE/${allowanceNameInInputBoxNew.allowance_name}/${initialAllowanceInAction.transaction_id}`;

    axios
      .post(apiUrl)
      .then((res) => {
        getAllowanceTypeList();
        setAllowanceNameInInputBoxNew(initialAllowanceInAction);
      }, {})
      .catch((err) => {});
  };

  // Allowance
  const editAllowanceAPI = () => {
    let apiUrl = `${base_url}/api/MasterReg/EDIT/${companyCode}/ALLOWANCE/${allowanceNameInInputBoxEdit.allowance_name}/${allowanceNameInInputBoxEdit.transaction_id}`;

    axios
      .post(apiUrl)
      .then((res) => {
        getAllowanceTypeList();
        setAllowanceNameInInputBoxEdit(initialAllowanceInActionEdit);
      }, {})
      .catch((err) => {});
  };

  const getAllowanceTypeList = async () => {
    const response = await axios.get(
      `${base_url}/api/MASTERLIST/${companyCode}/ALLOWANCE/-`,
    );
    if (response?.data) {
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );

      setAllowanceListFromAPI(newArray);
    } else {
      console.log("error");
    }
  };

  return (
    <div className="alowance-data">
      <div>
        <form action="" onSubmit={formik.handleSubmit}>
          <table className="shadow-sm min-w-full bg-white rounded-sm border border-[gray-300] text-xs ">
            <thead>
              <tr className="bg-[#2663EB] text-white text-sm">
                <th className="px-2 py-1 border-none  font-semibold">
                  Allowance Type
                </th>
                <th className="px-2 py-1 border-none font-semibold">Amount</th>
                <th className="px-2 py-1 border-none font-semibold">Date</th>
                <th className="px-2 py-1 border-none font-semibold">Reason</th>
                <th className="px-2 py-1 border-none font-semibold text-center">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className=" border">
                  {/* <input
                  type="text"
                  className="form-control bg-red-500"
                  name="AllowanceType"
                  onChange={formik.handleChange("AllowanceType")}
                  onBlur={formik.handleBlur("AllowanceType")}
                  value={formik.values.AllowanceType}
                /> */}
                  <div className="flex justify-between items-center gap-2 ">
                    <select
                      name="AllowanceType"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.AllowanceType}
                      className="
    w-full
    px-2 py-2
    text-sm
    border
    rounded
    outline-none
    focus:ring-0 focus:ring-blue-500
    focus:border-blue-500
  "
                    >
                      <option value="">Select Allowance Type</option>
                      {/* <option value="Fixed">Fixed</option>
                      <option value="Percentage">Percentage</option>
                      <option value="Bonus">Bonus</option> */}
                      {allowanceListFromAPI?.map((item, index) => (
                        <option key={index} value={item.Description}>
                          {item.Description}
                        </option>
                      ))}
                    </select>
                    <button
                      type="button"
                      onClick={() => setShowAllowanceCreationEditPopup(true)}
                      className="bg-blue-500 hover:bg-blue-700 px-2 py-1 text-white font-semibold rounded-md mr-2"
                    >
                      Manage
                    </button>
                  </div>
                </td>
                <td className="border">
                  <input
                    // type="text"
                    type="number"
                    // className="form-control"
                    className="
    w-full
    px-3 py-2
    text-sm
    border-none
    outline-none
    focus:ring-2 focus:ring-blue-500
    focus:border-blue-500
  "
                    name="Amount"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    // onChange={formik.handleChange("Amount")}
                    // onBlur={formik.handleBlur("Amount")}
                    value={formik.values.Amount}
                  />
                </td>
                <td className="border">
                  <input
                    type="date"
                    // className="form-control"
                    className="
    w-full
    px-3 py-2
    text-sm
    border-none
    outline-none
    focus:ring-2 focus:ring-blue-500
    focus:border-blue-500
  "
                    ref={ref}
                    name="ADate"
                    placeholder="Date"
                    onFocus={() => (ref.current.type = "date")}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    // onChange={formik.handleChange("ADate")}
                    // onBlur={formik.handleBlur("ADate")}
                    value={formik.values.ADate}
                    // value={dayjs(formik.values.ADate).format('YYYY-MM-DD')}
                    //  <TableCell>{dayjs(item?.APRV_DT).format('YYYY-MM-DD')}</TableCell>
                  />{" "}
                </td>
                <td className="border">
                  <input
                    type="text"
                    // className="form-control"
                    className="
    w-full
    px-3 py-2
    text-sm
    border-none
    outline-none
    focus:ring-2 focus:ring-blue-500
    focus:border-blue-500
  "
                    name="AffectOTCalc"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    // onChange={formik.handleChange("AffectOTCalc")}
                    // onBlur={formik.handleBlur("AffectOTCalc")}
                    value={formik.values.AffectOTCalc}
                  />
                </td>
                <td className="px-2 py-1 border text-center">
                  {/* <button
                    type="submit"
                    onClick={formik.handleSubmit}
                    disabled={isCreateDisabled}
                    className={`
    inline-flex items-center justify-center
    px-3 py-1.5
    text-sm font-semibold
    rounded-xl
    transition-all duration-200
    shadow-md
    ${
      isCreateDisabled
        ? "bg-gray-300 text-gray-500 cursor-not-allowed"
        : "bg-green-600 hover:bg-green-700 text-white active:scale-95"
    }
  `}
                  >
                    Create
                  </button> */}
                  {isCreateDisabled ? (
                    <Tooltip
                      title="Please fill empid, type, reason, amount, date fields"
                      arrow
                    >
                      <span>
                        <button
                          type="submit"
                          disabled
                          className={`
          inline-flex items-center justify-center
          px-3 py-1.5
          text-sm font-semibold
          rounded-xl
          transition-all duration-200
          shadow-md
          bg-gray-300 text-gray-500 cursor-not-allowed
        `}
                        >
                          Create
                        </button>
                      </span>
                    </Tooltip>
                  ) : (
                    <button
                      type="submit"
                      onClick={formik.handleSubmit}
                      className={`
      inline-flex items-center justify-center
      px-3 py-1.5
      text-sm font-semibold
      rounded-xl
      transition-all duration-200
      shadow-md
      bg-green-600 hover:bg-green-700 text-white active:scale-95
    `}
                    >
                      Create
                    </button>
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </form>
      </div>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setOpenSnackbar(false)}
          severity="success"
          sx={{ width: "100%" }}
        >
          Allowance created successfully!
        </Alert>
      </Snackbar>
      <Snackbar
        open={openErrorSnackbar}
        autoHideDuration={3000} // 3 seconds
        onClose={() => setOpenErrorSnackbar(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setOpenErrorSnackbar(false)}
          severity="error"
          sx={{ width: "100%" }}
        >
          {errorMessage}
        </Alert>
      </Snackbar>
      {showAllowanceCreationEditPopup && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
          {/* Modal Card */}
          <div className="w-[95%] max-w-xl bg-white rounded-2xl shadow-2xl p-6 max-h-[60vh] overflow-y-auto scrollbar-none">
            {/* Header */}
            <div className="flex items-center justify-between border-b pb-3">
              <h2 className="text-lg font-semibold text-[#2663EB] flex items-center gap-2">
                <BusinessIcon className="text-[#2663EB]" />
                ALLOWANCE TYPE MANAGEMENT
              </h2>

              <button
                onClick={() => setShowAllowanceCreationEditPopup(false)}
                className="p-2 rounded-full hover:bg-gray-100 transition"
              >
                <CloseIcon />
              </button>
            </div>

            {/* Add New ALLOWANCE */}
            <div className="mt-6 flex flex-col sm:flex-row gap-3 items-start sm:items-center">
              <input
                value={allowanceNameInInputBoxNew.allowance_name}
                type="text"
                placeholder="Enter new allowance type here..."
                className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#2663EB]/30 focus:border-[#2663EB] transition"
                onChange={(e) =>
                  setAllowanceNameInInputBoxNew((prev) => ({
                    ...prev,
                    allowance_name: e.target.value,
                  }))
                }
              />

              <button
                type="button"
                onClick={newAllowanceAPI}
                className="
          inline-flex items-center gap-2
          bg-blue-500
          text-white
          w-1/2
          px-2 py-1
          text-sm font-semibold
          rounded-md
          shadow-lg
          hover:from-blue-700 hover:to-blue-600
          active:scale-95
          transition-all duration-200
          focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2
        "
              >
                <Plus size={16} />
                Add Allowance
              </button>
            </div>

            {/* Allowance */}
            <div className="mt-6 space-y-3">
              {allowanceListFromAPI?.map((item) => {
                const isEditing =
                  allowanceNameInInputBoxEdit.transaction_id
                    ?.trim()
                    ?.toLowerCase() === item.TranId?.trim()?.toLowerCase();

                return (
                  <div
                    key={item.TranId}
                    className="border border-gray-200 rounded-xl px-2 py-1 hover:shadow-md transition"
                  >
                    {/* Row Header */}
                    <div className="flex items-center justify-between">
                      <span className="font-medium text-gray-700">
                        {item.Description}
                      </span>

                      <button
                        type="button"
                        onClick={() =>
                          setAllowanceNameInInputBoxEdit({
                            allowance_name: item.Description,
                            transaction_id: item.TranId,
                          })
                        }
                        className="p-2 rounded-md hover:bg-gray-100 transition"
                      >
                        <EditIcon fontSize="small" className="text-gray-600" />
                      </button>
                    </div>

                    {/* Edit Section */}
                    {isEditing && (
                      <div className="mt-4 flex flex-col sm:flex-row gap-3">
                        <input
                          type="text"
                          value={allowanceNameInInputBoxEdit.allowance_name}
                          onChange={(e) =>
                            setAllowanceNameInInputBoxEdit((prev) => ({
                              ...prev,
                              allowance_name: e.target.value,
                            }))
                          }
                          className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#2663EB]/30 focus:border-[#2663EB] transition"
                        />

                        <div className="flex gap-2">
                          <button
                            type="button"
                            onClick={() =>
                              setAllowanceNameInInputBoxEdit(
                                initialAllowanceInActionEdit,
                              )
                            }
                            className="flex items-center gap-1 px-3 py-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100 transition"
                          >
                            <CancelIcon fontSize="small" />
                            Cancel
                          </button>

                          <button
                            type="button"
                            onClick={editAllowanceAPI}
                            className="flex items-center gap-1 bg-green-600 text-white px-3 py-2 rounded-lg hover:bg-green-700 transition"
                          >
                            <SaveIcon fontSize="small" />
                            Save
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CreateAllowance;
